module.exports = __webpack_public_path__ + "static/media/imgop_EPSRC-logo.c238e83f.webp";